module.exports = __webpack_public_path__ + "static/media/cart.3ff203fa.svg";